import { TModel as TPartner } from 'legacy/lut/classes/models/PartnerOld'

import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { HttpCancel } from 'core/classes/http'
import { CrudHelper } from 'core/types/helpers/CrudHelper'
import Logger from 'core/utils/Logger'

export interface IPartnerDataFetchResult {
  items: TPartner[]
  total: number
}

class PartnerImagesApi {
  public fetchPartnerImages = async (partnerId: string, cancelObject?: HttpCancel) => {
    const crudHelper = new CrudHelper(504, 'CompanyPOSImages')
    const filter: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [{ field: 'PartnerId', value: partnerId, operator: Operator.EQUAL }],
    }
    const response = await crudHelper
      .read(filter, undefined, undefined, undefined, cancelObject, undefined, true)
      .catch(Logger.error)
    const responseData = response['Data'] || null
    if (responseData && responseData['Errors']) {
      throw new Error(responseData['Errors'])
    }
    return {
      items: (response && response['Data']) || [],
      total: 0,
    }
  }

  public setPartnerImage = async (
    item: any,
    action: 'create' | 'update' | 'delete'
  ): Promise<any> => {
    const crudHelper = new CrudHelper(504, 'CompanyPOSImages')
    const data = await crudHelper[action]([item])
    return (data || []).length ? data[0] : null
  }
}

const partnerImagesApi = new PartnerImagesApi()
export { partnerImagesApi }
